import * as React from 'react';
import { Modal, Button, TextField, Typography, Box } from '@material-ui/core';

/**
 * Generic confirmation modal for actions that require user confirmation
 * Supports optional reason input for audit tracking
 */
export default function ConfirmActionModal({
  openModal,
  setOpenModal,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  requiresReason = false,
  onConfirm,
}) {
  const [reason, setReason] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm(requiresReason ? reason : null);
      setOpenModal(false);
      setReason('');
    } catch (error) {
      console.error('Confirmation modal error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpenModal(false);
    setReason('');
  };

  return (
    <Modal open={openModal} onClose={handleClose}>
      <div className='relative overflow-y-auto max-h-96 top-2 md:top-10 m-auto bg-white rounded-lg md:px-8 px-3 py-4 z-50 lg:w-1/3 w-11/12 border-solid border border-gray-300'>
        <div
          className='absolute right-4 top-4 cursor-pointer text-gray-600 hover:text-gray-900'
          onClick={handleClose}
        >
          ✕
        </div>

        <Typography variant='h6' component='h2' className='mb-4 pr-8'>
          {title}
        </Typography>

        <Typography variant='body1' className='mb-4'>
          {message}
        </Typography>

        {requiresReason && (
          <Box className='mb-4'>
            <TextField
              label='Reason (optional)'
              multiline
              rows={3}
              fullWidth
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              variant='outlined'
              size='small'
              placeholder='Provide a reason for this action...'
            />
          </Box>
        )}

        <Box className='flex justify-end gap-2 mt-6'>
          <Button
            variant='outlined'
            onClick={handleClose}
            disabled={loading}
            className='text-gray-600 border-gray-300'
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? 'Processing...' : 'Confirm'}
          </Button>
        </Box>
      </div>
    </Modal>
  );
}
